import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Mismo proyecto Firebase que la app Electron.
// La apiKey es pública (se protege con Firestore rules + custom claim admin).
const firebaseConfig = {
  apiKey: 'AIzaSyBwaN0kSqg6JoFe01PAlvuYGh4MmADGUrQ',
  authDomain: 'auth.tikcontrol.live',
  projectId: 'tikcontrol-b4d1a',
  storageBucket: 'tikcontrol-b4d1a.firebasestorage.app',
  messagingSenderId: '55203790074',
  appId: '1:55203790074:web:9337715a5cef72ff5f1d43'
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
